import axios from 'axios';

import { TemperatureRegime } from '@/types/temperature-regime';

/**
 * Полученает список температурных режимов
 */
export const getTemperatureConditions = async () => {
	const { data } = await axios.get<TemperatureRegime[]>(
		`${process.env.HOST}/api_v1/temperature-conditions/`,
	);

	return data;
};
